import { Alert, AlertTitle, IconButton } from '@mui/material';
import { BannerCloseIcon, BannerInfoIcon } from 'components/CommonIcons/Icons';

const BANNER_COLORS = {
    background: '#E6EBF1',
    text: '#070A0E',
    iconColor: '#003771',
};

const BANNER_SX = {
    '&.MuiPaper-root': {
        padding: '0px 10px 0px 5px !important',
    },
    alignItems: 'flex-start',
    backgroundColor: `${BANNER_COLORS.background} !important`,
    color: 'text.primary',
    '& .MuiAlert-message': {
        width: '100%',
        overflowWrap: 'anywhere',
        fontSize: '14px',
        lineHeight: '25px',
        fontWeight: 400,
        color: BANNER_COLORS.text,
    },
};

interface BannerProps {
    message?: string | null;
    severity: 'error' | 'info' | 'success' | 'warning';
    title?: string | null;
    onDismiss?: () => void;
}

const Banner = ({ message, severity, title, onDismiss }: BannerProps) => {
    return (
        <Alert
            severity={severity}
            icon={<BannerInfoIcon color={BANNER_COLORS.iconColor} />}
            action={onDismiss && (
                <IconButton
                    aria-label="Close banner"
                    title="Close banner"
                    color="inherit"
                    size="small"
                    onClick={onDismiss}
                >
                    <BannerCloseIcon color={BANNER_COLORS.iconColor} />
                </IconButton>
            )}
            sx={BANNER_SX}
        >
            {title && (
                <AlertTitle sx={{ fontSize: '16px', color: `${BANNER_COLORS.iconColor}`, fontWeight: 500, lineHeight: '25px' }}>
                    {title}
                </AlertTitle>
            )}
            {message}
        </Alert>
    );
};

export default Banner;